module.exports = __webpack_public_path__ + "media/fonts/NotoEmoji-0065ce9f4db9c1e5b7f1fc9df70c1fb7.ttf";